import {
  html,
  SYSFormElement,
  unsafeHTML,
} from "../../../../../../../_ovlclient/src"
import { postRequest } from "../../../../../../../_ovlclient/src/effects"
import { DialogOk } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  FieldForceChange,
  FieldVal,
  SYSField,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormHasVisibleSummaryErrors,
  FormIsValid,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  ScreenNavigateBack,
  ScreenNavigateTo,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import {
  SnackAdd,
  SnackTrackedAdd,
  SnackTrackedRemove,
} from "../../../../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import { NewServiceStep3FormFieldKeys } from "../../../features/svl/svlnewservicestep3/formdef"
import { validateCaptcha } from "../../../global/helpers"

export class NewServiceStep3 extends SYSFormElement {
  newService: typeof this.state.app.global.SVL.NewService
  lookups: typeof this.state.app.global.SVL.lookups
  async init() {
    this.screen = "SVLNewServiceStep3"
    this.formType = "SVLNewServiceStep3"
    this.newService = this.state.app.global.SVL.NewService
    this.lookups = this.state.app.global.SVL.lookups
    await super.init()
  }

  async handleStep3(e: Event) {
    let res

    let snackText
    snackText = T("NewServiceSnackDataProcessing")
    let NewService = this.state.app.global.SVL.NewService
    let snackId = SnackTrackedAdd(snackText, "BusyIndicator")
    try {
      let token = await validateCaptcha()
      if (token) {
        let selectedSlot = NewService.selectedSlot
        let formStateStep1 =
          this.state.ovl.forms["SVLNewServiceStep1"]["SVLNewServiceStep1"]
        let formStateStep2 =
          this.state.ovl.forms["SVLNewServiceStep2"]["SVLNewServiceStep2"]
        let equipment = {
          id: NewService.equipment.id,
          buildingType:
            this.formState.fields["objectBuildingType"].convertedValue,
        }
        let cardType =
          this.state.app.global.SVL.lookups.cardGroup.data[
            NewService.contact.cardGroup
          ]["CardType"]
        let contact = {
          id: NewService.contact.id,
          email: NewService.contact.email,
          phone: FieldVal(formStateStep1.fields["requesterPhone"]),
          firstName: FieldVal(formStateStep2.fields["requesterFirstName"]),
          lastName: FieldVal(formStateStep2.fields["requesterLastName"]),
          firstNameC: NewService.contact.firstNameC,
          lastNameC: NewService.contact.lastNameC,
          emailC: NewService.contact.emailC,
          phoneC: NewService.contact.mobilePhoneC,
          cardGroup: parseInt(NewService.contact.cardGroup),
          cardType,
        }
        if (cardType === "1") {
          contact.firstNameC = ""
          contact.lastNameC = ""
          contact.phoneC = ""
          contact.emailC = ""
        }

        let slotsData = NewService.slotFinder.slots.data
        let problemData = this.state.app.global.SVL.lookups.problemType.data
        let problemType = NewService.selectedProblemType
        let planning = {
          startDateForCheck: selectedSlot,
          startDateToUse: slotsData[selectedSlot]["DateToUse"],
          cost: slotsData[selectedSlot]["Cost"],
          item: slotsData[selectedSlot]["Item"],
          duration: problemData[problemType].Duration,
          problemDesc: problemData[problemType].ProblemDesc,
          problemType: problemType.toString(),
        }
        let additionalInfo = {
          promoCode:
            FieldVal(formStateStep1.fields["promoCode"]) +
            "-" +
            FieldVal(formStateStep1.fields["promoCode2"]) +
            "-" +
            FieldVal(formStateStep1.fields["promoCode3"]),
          generalRemarks: FieldVal(this.formState.fields["generalRemarks"]),
          orderReference: FieldVal(this.formState.fields["orderReference"]),
        }
        let apiUrl = this.state.ovl.apiUrl + "plan/plan"
        // SnackAdd(
        //   `@@Log: Contact poested to planning: ${JSON.stringify(contact)}`
        // )
        res = await postRequest(apiUrl, {
          equipment,
          location: {
            city: NewService.objectLocationParams.City,
            zipCode: NewService.objectLocationParams.ZipCode,
            street: NewService.objectLocationParams.Street,
            streetNr: NewService.objectLocationParams.Nr,
          },
          contact,
          planning,
          additionalInfo,
          token,
        })
        SnackTrackedRemove(snackId)
        if (res.data) {
          if (!res.data.error) {
            await DialogOk(T("NewServiceDialogProcessFinished"), {
              customClass: "oru-sl-success",
            })
            window.location.replace(T("NewServiceLinkProcessFinishedRedirect"))
          } else {
            DialogOk(T("NewServiceDialogSlotStolen"))
            FieldForceChange(formStateStep1.fields["planningStartDate"])
            // FieldSetVal(formStateStep1.fields["planningStartDate"], undefined, {
            //   resetChanged: true,
            // })
            NewService.slotFinder.slots.data = {}
            ScreenNavigateTo("SVLNewServiceStep1")
          }
        } else {
          await DialogOk(T("NewServiceDialogErrorUnrecoverable"))
          window.location.replace(T("NewServiceLinkProcessFinishedRedirect"))
        }
      }
    } finally {
      SnackTrackedRemove(snackId)
    }
  }

  async getUI() {
    let fields: { [key in NewServiceStep3FormFieldKeys]: SYSField } = <any>(
      this.formState.fields
    )
    let objectBuildingTypeField = fields["objectBuildingType"]
    let generalRemarksField = fields["generalRemarks"]
    let agbConfirmationField = fields["agbConfirmation"]
    let orderReferenceField = fields["orderReference"]

    let agbConfirmation = html`
      <ovl-checkbox .props=${() => agbConfirmationField}> </ovl-checkbox>
    `
    let generalRemarks = html`
      <ovl-textarea .props=${() => generalRemarksField}> </ovl-textarea>
    `

    let orderRefrence = html`
      <ovl-textbox .props=${() => orderReferenceField}> </ovl-textbox>
    `

    let objectBuildingType
    if (!this.state.app.global.SVL.NewService.equipment.id) {
      objectBuildingType = html`
        <fieldset class="fd-fieldset">
          <legend class="fd-fieldset__legend">
            ${T("NewServiceBuildingType")}
          </legend>
          <ovl-listcontrol .props=${() => objectBuildingTypeField}>
          </ovl-listcontrol>
        </fieldset>
      `
    }

    let cardType =
      this.lookups.cardGroup.data[this.newService.contact.cardGroup]["CardType"]
    let problemDesc =
      this.lookups.problemType.data[this.newService.selectedProblemType][
        "ProblemDesc"
      ]
    let slotAndCostInfos =
      this.newService.slotFinder.slots.data[this.newService.selectedSlot][
        "Params"
      ]
    let contact = this.newService.contact
    let reps = [
      contact.mobilePhone,
      contact.email,
      contact.firstNameC,
      contact.lastNameC,
      contact.mobilePhoneC,
      contact.emailC,
      slotAndCostInfos[0],
      slotAndCostInfos[1],
      slotAndCostInfos[2],
      slotAndCostInfos[3],
      slotAndCostInfos[4],
      slotAndCostInfos[5],
      problemDesc,
      this.newService.objectLocationParams.Street,
      this.newService.objectLocationParams.Nr,
      this.newService.objectLocationParams.ZipCode,
      this.newService.objectLocationParams.City,
    ]
    let summary = T("NewServiceSummaryText" + cardType, reps)

    let SummaryHint
    if (FormHasVisibleSummaryErrors(this.formState)) {
      SummaryHint = html`
        <ovl-formvalidationhint
          .props=${() => this.formState}
        ></ovl-formvalidationhint>
      `
    }

    return html`
      <div class="fd-layout-panel">
        <itf-newserviceheader></itf-newserviceheader>
        <div class="fd-layout-panel__body">
          ${objectBuildingType}
          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServiceAdditionalInfo")}
            </legend>
            ${orderRefrence} ${generalRemarks}
          </fieldset>

          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServiceSummary")}
            </legend>
            <div class="summarytext">${unsafeHTML(summary)}</div>
          </fieldset>

          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">${T("NewServiceAGB")}</legend>
            ${agbConfirmation}
          </fieldset>
          ${SummaryHint}
        </div>
        <div class="fd-layout-panel__footer itf-2-cols">
          <button
            class="fd-button"
            @click=${(e) => {
              ScreenNavigateBack()
            }}
          >
            ${T("NewServiceNavigateBack")}
          </button>
          <button
            class="fd-button"
            ?disabled=${!FormIsValid(this.formState)}
            @click=${(e) => this.handleStep3(e)}
          >
            ${T("NewServiceCreateServiceStep3")}
          </button>
        </div>
        <itf-newservicefooter></itf-newservicefooter>
      </div>
    `
  }
}
